import { withStyles } from "@material-ui/core/styles";

import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ShowButton,
  TextField,
  EditButton,
  TextInput,
  SelectInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="storage" alwaysOn />,
  <TextInput label="Freezer" source="freezer" />,
  <SelectInput
    label="Type"
    source="type"
    choices={[
      { id: "Petri", name: "Petri" },
      { id: "Tube", name: "Tube" },
      { id: "Plate", name: "Plate" },
      { id: "Other", name: "Other" },
    ]}
  />,
];

export const StoragesList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    sort={{ field: "storage", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={25}
  >
    <Datagrid>
      <TextField source="storage" />
      <TextField source="freezer" />
      <TextField source="type" />
      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
